/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { WorkSession__EntityFragmentDoc } from '../../projects/boxes/ProjectOverviewWorkSessionsBox.generated.js';
import { TaskTreeItem_TreeListItemFragmentDoc, TaskTreeItem_TreeSimpleItemFragmentDoc } from '../trees.generated.js';
import { WorkSession__ItemEntityFragmentDoc } from '../../work-sessions/Fragments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TasksTimesheetTasksFormQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  assigneeId: Types.Scalars['ID']['input'];
  date: Types.Scalars['Date']['input'];
}>;


export type TasksTimesheetTasksFormQuery = { project: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, tasks: Array<{ __typename: 'TaskDocument', id: string, viewerPermissions: Array<Types.PermissionName>, agreement: Types.Agreement, workSessions: Array<{ __typename: 'WorkSession', id: string, from?: any | null, till?: any | null, date?: any | null, duration?: number | null, isBreak: boolean, isCorrection: boolean, itemId?: string | null }> }> } | null } };

export type TasksTimesheetTasksForm_ItemFragment = { __typename: 'Item', id: string, title: string, timeTrackingRequired: boolean, isDone: boolean, photoApprovalRequired: boolean, qaApprovalRequired: boolean, approvalRequired: boolean, workSessionsDuration: number, priority: number, docId: string, type: Types.ItemType, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, deletedAt?: any | null, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, dueDate?: any | null, doneDate?: any | null, isVisibleToOtherSide: boolean, isQaApproved?: boolean | null, isApproved?: boolean | null, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null, assignee?: { __typename: 'User', id: string, firstname: string, familyname: string } | null, photoApproved?: { __typename: 'AttachmentSnapshot', id: string } | null, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export type CorrectWorkSession_TasksFormMutationVariables = Types.Exact<{
  input: Types.CorrectWorkSessionInput;
  assigneeId: Types.Scalars['ID']['input'];
  date: Types.Scalars['Date']['input'];
}>;


export type CorrectWorkSession_TasksFormMutation = { correctWorkSession: { __typename: 'CorrectWorkSessionResult', workSession?: { __typename: 'WorkSession', id: string } | null, item: { __typename: 'Item', id: string, originVersionNumber?: number | null, workSessionsDuration: number, workSessions: Array<{ __typename: 'WorkSession', id: string, till?: any | null, from?: any | null, date?: any | null, duration?: number | null, isCorrection: boolean, assignee?: { __typename: 'User', id: string, firstname: string, familyname: string } | null, author: { __typename: 'User', id: string, firstname: string, familyname: string } }> }, project: { __typename: 'Project', id: string, tasks: Array<{ __typename: 'TaskDocument', id: string, workSessions: Array<{ __typename: 'WorkSession', id: string, from?: any | null, till?: any | null, date?: any | null, duration?: number | null, isBreak: boolean, isCorrection: boolean, itemId?: string | null }> }> } } };

export const TasksTimesheetTasksForm_ItemFragmentDoc = gql`
    fragment TasksTimesheetTasksForm_Item on Item {
  id
  title
  timeTrackingRequired
  isDone
  photoApprovalRequired
  qaApprovalRequired
  approvalRequired
  workSessionsDuration
  priority
  ...TaskTreeItem_TreeListItem
  ...TaskTreeItem_TreeSimpleItem
}
    ${TaskTreeItem_TreeListItemFragmentDoc}
${TaskTreeItem_TreeSimpleItemFragmentDoc}`;
export const TasksTimesheetTasksFormDocument = gql`
    query TasksTimesheetTasksForm($projectId: ID!, $assigneeId: ID!, $date: Date!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        tasks {
          id
          viewerPermissions
          agreement
          workSessions(assigneeId: $assigneeId, date: $date) {
            id
            ...WorkSession__Entity
          }
        }
      }
    }
  }
}
    ${WorkSession__EntityFragmentDoc}`;

/**
 * __useTasksTimesheetTasksFormQuery__
 *
 * To run a query within a React component, call `useTasksTimesheetTasksFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksTimesheetTasksFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksTimesheetTasksFormQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      assigneeId: // value for 'assigneeId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTasksTimesheetTasksFormQuery(baseOptions: Apollo.QueryHookOptions<TasksTimesheetTasksFormQuery, TasksTimesheetTasksFormQueryVariables> & ({ variables: TasksTimesheetTasksFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksTimesheetTasksFormQuery, TasksTimesheetTasksFormQueryVariables>(TasksTimesheetTasksFormDocument, options);
      }
export function useTasksTimesheetTasksFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksTimesheetTasksFormQuery, TasksTimesheetTasksFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksTimesheetTasksFormQuery, TasksTimesheetTasksFormQueryVariables>(TasksTimesheetTasksFormDocument, options);
        }
export function useTasksTimesheetTasksFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TasksTimesheetTasksFormQuery, TasksTimesheetTasksFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TasksTimesheetTasksFormQuery, TasksTimesheetTasksFormQueryVariables>(TasksTimesheetTasksFormDocument, options);
        }
export type TasksTimesheetTasksFormQueryHookResult = ReturnType<typeof useTasksTimesheetTasksFormQuery>;
export type TasksTimesheetTasksFormLazyQueryHookResult = ReturnType<typeof useTasksTimesheetTasksFormLazyQuery>;
export type TasksTimesheetTasksFormSuspenseQueryHookResult = ReturnType<typeof useTasksTimesheetTasksFormSuspenseQuery>;
export type TasksTimesheetTasksFormQueryResult = Apollo.QueryResult<TasksTimesheetTasksFormQuery, TasksTimesheetTasksFormQueryVariables>;
export const CorrectWorkSession_TasksFormDocument = gql`
    mutation CorrectWorkSession_TasksForm($input: CorrectWorkSessionInput!, $assigneeId: ID!, $date: Date!) {
  correctWorkSession(input: $input) {
    workSession {
      id
    }
    item {
      id
      originVersionNumber
      workSessionsDuration
      workSessions {
        id
        ...WorkSession__ItemEntity
      }
    }
    project {
      id
      tasks {
        id
        workSessions(assigneeId: $assigneeId, date: $date) {
          id
          ...WorkSession__Entity
        }
      }
    }
  }
}
    ${WorkSession__ItemEntityFragmentDoc}
${WorkSession__EntityFragmentDoc}`;
export type CorrectWorkSession_TasksFormMutationFn = Apollo.MutationFunction<CorrectWorkSession_TasksFormMutation, CorrectWorkSession_TasksFormMutationVariables>;

/**
 * __useCorrectWorkSession_TasksFormMutation__
 *
 * To run a mutation, you first call `useCorrectWorkSession_TasksFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorrectWorkSession_TasksFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [correctWorkSessionTasksFormMutation, { data, loading, error }] = useCorrectWorkSession_TasksFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *      assigneeId: // value for 'assigneeId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCorrectWorkSession_TasksFormMutation(baseOptions?: Apollo.MutationHookOptions<CorrectWorkSession_TasksFormMutation, CorrectWorkSession_TasksFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CorrectWorkSession_TasksFormMutation, CorrectWorkSession_TasksFormMutationVariables>(CorrectWorkSession_TasksFormDocument, options);
      }
export type CorrectWorkSession_TasksFormMutationHookResult = ReturnType<typeof useCorrectWorkSession_TasksFormMutation>;
export type CorrectWorkSession_TasksFormMutationResult = Apollo.MutationResult<CorrectWorkSession_TasksFormMutation>;
export type CorrectWorkSession_TasksFormMutationOptions = Apollo.BaseMutationOptions<CorrectWorkSession_TasksFormMutation, CorrectWorkSession_TasksFormMutationVariables>;